import { create } from 'zustand';
import { type AuthUser, type Permission, UserRole } from '@/types/auth';

interface AuthState {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setUser: (user: AuthUser) => void;
  clearUser: () => void;
  hasPermission: (permission: Permission) => boolean;
  canViewDepartment: (department: string) => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,

  setUser: (user: AuthUser) => {
    set({ user, isAuthenticated: true, isLoading: false });
  },

  clearUser: () => {
    set({ user: null, isAuthenticated: false, isLoading: false });
  },

  hasPermission: (permission: Permission): boolean => {
    const { user } = get();
    if (!user) return false;
    return user.permissions?.includes(permission) ?? false;
  },

  canViewDepartment: (department: string): boolean => {
    const { user } = get();
    if (!user) return false;

    if (
      user.role === UserRole.CCO ||
      user.role === UserRole.COMPLIANCE_REP
    ) {
      return true;
    }

    return user.departments?.includes(department) ?? false;
  },
}));
